import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Checkbox, Row, Col, Spin } from 'antd'
import cancellationRequests from '@services/cancellationRequests'
import { alertPopup } from '@utils/popup'
import { FINANCE_USER_ID } from '@constants/index'

import style from './style'

@inject((store: any) => {
    const { cancellationRequestStore, authStore } = store
    return {
        cancellationRequestStore,
        authStore
    }
})
@observer
export class Recipients extends Component<any, any> {
    financeUser = FINANCE_USER_ID // user id of Nurit Ak.

    constructor(props) {
        super(props)
        this.state = {
            values: [],
            edit: false,
            spin: false
        }
    }

    componentDidMount(): void {
        this.initializeStateFromProps()
    }

    componentDidUpdate(prevProps) {
        // Compare only by reqId: the parent rebuilds `existingRecipients` (a fresh
        // object) on every render, so a reference compare would re-init the state
        // on any parent re-render and wipe unsaved checkbox selections.
        if (prevProps.info.reqId !== this.props.info.reqId) {
            this.initializeStateFromProps()
        }
    }

    getDefaultRecipients = () => {
        const {
            info: { existingRecipients }
        } = this.props

        const existing =
            existingRecipients && Array.isArray(existingRecipients.recipients) ? existingRecipients.recipients : []

        return existing.find(id => `${id}` === `${this.financeUser}`) ? existing : [...existing, this.financeUser]
    }

    initializeStateFromProps = () => {
        const {
            authStore: { roles, id },
            info: { existingRecipients }
        } = this.props
        const safeRoles = roles || []

        const edit =
            safeRoles.includes('admin') ||
            safeRoles.includes('moderator') ||
            safeRoles.includes('money') ||
            (existingRecipients &&
                Array.isArray(existingRecipients.recipients) &&
                existingRecipients.recipients.find(recId => `${recId}` === `${id}`))

        this.setState({ edit: !!edit, values: this.getDefaultRecipients() })
    }

    updateRecipients = values => {
        const nextValues = values.find(id => `${id}` === `${this.financeUser}`) ? values : [...values, this.financeUser]
        this.setState({ values: nextValues })
    }

    sendRecipients = () => {
        const {
            info: { reqId, onClose },
            cancellationRequestStore: { updateListLocally }
        } = this.props

        const { values } = this.state

        this.setState({ spin: true }, () => {
            cancellationRequests
                .updateCancellationRequest({ requestId: reqId, recipients: values })
                .then(res => {
                    this.setState({ spin: false })
                    updateListLocally({ request: res.data.cancellation_request })
                    onClose()
                })
                .catch(error => {
                    this.setState({ spin: false })
                    this.props.cancellationRequestStore.refreshOnConflict(error)
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: `עדכון רשימת מכותבים נכשל` })
                })
        })
    }

    render() {
        const {
            info: { users, requested_for_id, full_name, onClose }
        } = this.props
        const { edit, values } = this.state

        const alwaysDisabled = { [this.financeUser]: this.financeUser }

        const defaultValues = this.getDefaultRecipients()

        let recipientList = []

        if (!edit) {
            let existingRecipientsObj = {}
            defaultValues.forEach(id => (existingRecipientsObj[id] = id))
            ;(users || []).forEach(user => {
                if (existingRecipientsObj[user.id]) recipientList.push(user)
            })
        } else {
            recipientList = users || []
        }

        return (
            <div style={style.style1} onClick={onClose}>
                <div style={{ ...style.style2, ...style.column }} onClick={e => e.stopPropagation()}>
                    <div style={{ ...style.headerStyle, ...style.column }}>
                        <div style={style.headerStyle.line1}>
                            <button style={style.headerStyle.closeBtn} onClick={onClose}>
                                +
                            </button>
                        </div>
                        <div style={style.headerStyle.line2}>
                            {edit && <span style={{ fontSize: '23px', fontWeight: '600' }}>עדכון רשימת מכותבים</span>}
                            {!edit && (
                                <>
                                    <span style={{ fontSize: '23px', fontWeight: '600' }}>רשימת מכותבים </span>
                                    <span style={{ fontSize: '16px', fontWeight: '400' }}>(אינך מורשי/ת עריכה)</span>
                                </>
                            )}
                        </div>
                        <div style={style.headerStyle.line3}>
                            <span
                                style={{ fontSize: '17px' }}
                            >{`בקשת ביטול עבור ${full_name} ${requested_for_id}`}</span>
                        </div>
                    </div>
                    <div style={style.contentStyle}>
                        {edit ? (
                            <Checkbox.Group
                                value={values.length ? values : defaultValues}
                                onChange={values => this.updateRecipients(values)}
                            >
                                {recipientList.map((user, index) => {
                                    return (
                                        <Row style={{ marginBottom: '20px' }} key={index.toString()}>
                                            <Col>
                                                <Checkbox
                                                    disabled={alwaysDisabled[user.id] ? true : false}
                                                    value={user.id}
                                                >
                                                    <span style={{ marginBottom: '20px' }}>
                                                        <span
                                                            style={{ fontSize: '16px' }}
                                                        >{`${user.first_name} ${user.last_name}`}</span>
                                                        <span
                                                            style={{ marginRight: '20px', fontSize: '16px' }}
                                                        >{`${user.email}`}</span>
                                                    </span>
                                                </Checkbox>
                                            </Col>
                                        </Row>
                                    )
                                })}
                            </Checkbox.Group>
                        ) : (
                            <div>
                                {recipientList.map((user, index) => {
                                    return (
                                        <div key={index.toString()} style={{ marginBottom: '20px' }}>
                                            <span
                                                style={{ fontSize: '16px' }}
                                            >{`${user.first_name} ${user.last_name}`}</span>
                                            <span
                                                style={{ marginRight: '20px', fontSize: '16px' }}
                                            >{`${user.email}`}</span>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                    <div style={style.footerStyle}>
                        {edit && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Button onClick={this.sendRecipients}>שמור</Button>
                                {this.state.spin && (
                                    <div style={{ width: '20px' }}>
                                        <Spin />
                                    </div>
                                )}
                            </div>
                        )}
                        {!edit && <Button onClick={onClose}>סגור</Button>}
                    </div>
                </div>
            </div>
        )
    }
}
